// ERP Attribute Engine — Grid Layout
export function GridLayout({ layout, visibleGroupIds, renderGroup }) {
  const visible = layout.placements
    .filter(p => visibleGroupIds.has(p.groupId))
    .sort((a, b) => a.row !== b.row ? a.row - b.row : a.colStart - b.colStart);

  const rows = visible.reduce((acc, p) => {
    (acc[p.row] = acc[p.row] || []).push(p);
    return acc;
  }, {});

  return (
    <div className="gl">
      {Object.entries(rows).map(([row, placements]) => (
        <div key={row} className="gl-row">
          {placements.map(p => (
            <div key={p.groupId} className="gl-col" style={{ gridColumn:`${p.colStart} / span ${p.colSpan}` }}>
              {renderGroup(p)}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
